export default {
      id: "dashboard-usage",
      viewBox: "0 0 25 19.88",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#dashboard",
      toString: function () {
        return this.url;
      }
    }